// Copyright (c) Microsoft. All rights reserved.

import { Action, Dispatch, Middleware } from '@reduxjs/toolkit';
import { AlertType } from '../../../libs/models/AlertType';
import { showAlertToast } from '../app/appSlice';
import { IChatMessage } from '../../../libs/models/conversations/ChatMessage';
import { RootState, StoreMiddlewareAPI, getSelectedChatID_V2 } from './../../app/store';
import { getOrCreateHubConnection } from './signalRHubConnection';
import { AIModelName } from '../../../libs/models/app/AIModel';
import { IFileAnalyzedCacheResult } from '../../../libs/models/conversations/File';
import { WebSearchSource } from '../../../libs/models/app/Plugin';
import { IMCPTool } from '../../../libs/models/app/mcp/Tool';

// The action sent to the SignalR middleware.
interface SignalRAction extends Action {
  payload: {
    message?: IChatMessage;
    userId?: string;
    isTyping?: boolean;
    id?: string;
    chatId?: string;
    model: AIModelName;
    plugin?: string;
    attachFiles?: IFileAnalyzedCacheResult[];
    cacheMode?: boolean;
    isDraft?: boolean;
    webSearchOn: boolean;
    webSearchSource: WebSearchSource;
    mcpTools?: IMCPTool[];
    agentMode?: boolean;
    sessionId?: string;
    agentId?: string;
    additionalProperties?: Record<string, object>;
  };
}

export const signalRMiddleware: Middleware<any, RootState, Dispatch<SignalRAction>> = (store: StoreMiddlewareAPI) => {
  return (next) => (action) => {
    // Call the next dispatch method in the middleware chain before performing any async logic
    const signalRAction = action as SignalRAction;
    const result = next(signalRAction);

    // Get the SignalR connection instance
    const hubConnection = getOrCreateHubConnection(store);

    // The following actions will be captured by the SignalR middleware and broadcasted to all clients.
    switch (signalRAction.type) {
      // AG-UI 전환: 채팅 메시지 전송은 agUiMiddleware에서 처리
      // case 'conversations/v2/addMessageToConversationFromUser':
      //   console.log('addMessageToConversationFromUser', signalRAction.payload.agentId)
      //   hubConnection
      //     .invoke('SendMessage', {
      //       SessionId: signalRAction.payload.sessionId,
      //       Message: signalRAction.payload.message,
      //       AIModelName: signalRAction.payload.model,
      //       AgentId: signalRAction.payload.agentId,
      //       AttachFiles: signalRAction.payload.attachFiles,
      //       CacheMode: signalRAction.payload.cacheMode,
      //       isDraft: signalRAction.payload.isDraft,
      //       webSearchOn: signalRAction.payload.webSearchOn,
      //       WebSearchSource: signalRAction.payload.webSearchSource,
      //       McpTools: signalRAction.payload.mcpTools,
      //       AgentMode: signalRAction.payload.agentMode,
      //     })
      //     .catch((err) => store.dispatch(showAlertToast({ altMessage: String(err), altType: AlertType.Info })));
      //   break;
      case 'conversations/v2/updateUserIsTyping':
        // hubConnection
        //     .invoke(
        //         'SendUserTypingStateAsync',
        //         getSelectedChatID(),
        //         signalRAction.payload.userId,
        //         signalRAction.payload.isTyping,
        //     )
        //     .catch((err) => store.dispatch(addAlert({ message: String(err), type: AlertType.Error })));
        break;
      case 'conversations/v2/setConversations':
        // Promise.all(
        //     Object.keys(signalRAction.payload).map(async (id) => {
        //         await hubConnection.invoke('AddClientToGroupAsync', id);
        //     }),
        // ).catch((err) => store.dispatch(addAlert({ message: String(err), type: AlertType.Error })));
        break;
      case 'conversations/v2/setSelectedConversation':
        console.log(signalRAction.payload);
        if(signalRAction.payload.id != '')
        hubConnection.invoke('JoinChatRoom', signalRAction.payload.id).catch((err) => {
          store.dispatch(showAlertToast({ altMessage: String(err), altType: AlertType.Info }));
        });
        break;
      case 'conversations/v2/addConversation':
        hubConnection
          .invoke('JoinChatRoom', signalRAction.payload.id)
          .catch((err) => store.dispatch(showAlertToast({ altMessage: String(err), altType: AlertType.Info })));
        break;
      case 'conversations/v2/leaveConversation':
        hubConnection
          .invoke('LeaveChatRoom', getSelectedChatID_V2())
          .catch((err) => store.dispatch(showAlertToast({ altMessage: String(err), altType: AlertType.Info })));
        break;
      // AG-UI 전환: 스트리밍 중단은 agUiMiddleware에서 처리
      // case 'conversations/v2/stopStreaming':
      //   hubConnection
      //     .invoke('StopStreaming', getSelectedChatID_V2())
      //     .catch((err) => store.dispatch(showAlertToast({ altMessage: String(err), altType: AlertType.Info })));
      //   break;

      // AG-UI 전환: 메시지 재생성은 agUiMiddleware에서 처리
      // case 'conversations/v2/retryMessageToConversationFromUser':
      //   const message = signalRAction.payload.message;
      //   hubConnection
      //     .invoke('SendRegenerateMessage', message?.id, {
      //       sessionId: getSelectedChatID_V2(),
      //       AIModelName: signalRAction.payload.model,
      //       mcpTools: signalRAction.payload.mcpTools
      //     })
      //     .catch((err) => {
      //       store.dispatch(
      //         showAlertToast({
      //           altMessage: String('다시 질문하지 못했어요. 잠시 후 다시 시도해주세요.'),
      //           altType: AlertType.Info,
      //         }),
      //       );
      //       console.error(String(err));
      //     });
      //   break;
    }

    return result;
  };
};
